import { render, staticRenderFns } from "./PaperPublishManagement.vue?vue&type=template&id=6d918006&scoped=true"
import script from "./PaperPublishManagement.vue?vue&type=script&lang=js"
export * from "./PaperPublishManagement.vue?vue&type=script&lang=js"
import style0 from "./PaperPublishManagement.vue?vue&type=style&index=0&id=6d918006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d918006",
  null
  
)

export default component.exports